import type {
  ClientResponse,
  ServerResponse,
} from '@onhandtech/onhand-fe-shared/lib/api/v5/request-filter-set/delete-filter-set/delete-filter-set.types'
import { moduleName } from '@onhandtech/onhand-fe-shared/lib/api/v5/request-filter-set/delete-filter-set/delete-filter-set.types'
import { handleSuccess } from '@onhandtech/onhand-fe-shared/lib/api/v5/request-filter-set/delete-filter-set/helpers/handle-success'
import { createReduxServiceModule } from '@onhandtech/onhand-fe-shared/lib/redux'
import type { RequestArgs } from '@onhandtech/onhand-fe-shared/lib/request'
import { createRequestError, formatEndpoint } from '@onhandtech/onhand-fe-shared/lib/request'
import type { AxiosError } from 'axios'
import { getConfig } from 'config/configuration'

const { endpoints } = getConfig()

const args: RequestArgs<ServerResponse, ClientResponse> = {
  method: 'DELETE',
  url: formatEndpoint(endpoints.api.v5.patchRequestFilterSet),
  handleSuccess,
  handleFailure: (error: AxiosError) =>
    createRequestError(error, error.status?.toString() ?? '', moduleName),
}

const deleteRequestFilterSetsModule = () =>
  createReduxServiceModule<ServerResponse, ClientResponse>({
    moduleName,
    args,
  })

export default deleteRequestFilterSetsModule
